module.exports = __webpack_public_path__ + "img/xinjiang_bg.95332b20.jpg";